/**
	This is called from pip default html when ReactFulfillmentTilesEnabled is turned on
	and after the js/css for the new experience is loaded
	init()
		preps layout by adding the buybelt-wrapper-new container for the new experience

	finishInit()
		finishes bindings and initializations for components reused in new experience
*/
import DomAdjuster from '../shims/dom-adjuster';
let PIP_HOOKS = null;
let $ = null;
let payPalInitialized = false;
class BuyBeltInit {
	static init(selectedOption, fulfillmentDetails){
		try{
			prepLayout();
	    }catch(e){
	      console.error(e);
	    }
	}

    static setPipHooks(pipHooks, pipModel){
        try{
            if(pipHooks && pipModel){
                PIP_HOOKS = pipHooks;
                PIP_HOOKS.pip = pipModel;
            }
        }catch(e){
          console.error(e);
        }
    }

	static finishInitialization(partialReload=false, fulfillmentDetails, selectedOption){
    if(!PIP_HOOKS){
        return;
    }
		try{
            $ = window.$;
            initPaypal();
            initAtcArea(partialReload, fulfillmentDetails, selectedOption)

		}catch(e){
			console.error(e);
		}
	}

    static initHowItWorks(){
      if(!PIP_HOOKS){
          return;
      }
      try{
        $ = window.$;
        const {Mustache, view, pip} = PIP_HOOKS;
        $('#howItWorksReact').tooltip({
            type: 'click',
            position: 'bottom',
            content: function () {
              return Mustache.render(
                    view.templates.raw.buybelt_delivery_tooltip__template,
                    pip.fulfillment.shipping.buyOnlineDeliverFromStore
                );
          },
            width: 'medium',
            closeButton: true,
            bestPosition: false,
            closeOnClick: true
          });
      }catch(e){
          console.error(e);
      }
    }

    static initTrackIf(){
      try{
        if(PIP_HOOKS && PIP_HOOKS.pipTrackif){
          PIP_HOOKS.pipTrackif.init();
        }
      }catch(e){
          console.error(e);
      }
    }

    static initICTooltip(){
      if(!PIP_HOOKS){
          return;
      }
      try{
          $ = window.$;
          const {pipInstantCheckout} = PIP_HOOKS;
          const view = pipInstantCheckout.view;
          $(view.selectors.instantCheckoutSettings).tooltip({
            type: 'click',
            position: 'bottom',
            content: view.templates.instantCheckoutTooltip,
            width: 'medium',
            closeButton: true,
            bestPosition: false,
            closeOnClick: true
          });
      }catch(e){
          console.error(e);
      }
    }

    static shouldDisplayLegacyScenario(){
      let showLegacy = false;
      try{
        showLegacy = _checkForDisplayLegacyScenario();
      }catch(e){
        console.error(e);
      }
      return showLegacy;
    }
}

function prepLayout() {
	try{
	    // document.querySelector('#buybelt-wrapper') && document.querySelector('#buybelt-wrapper').classList.add('u--hide');
	    // document.querySelector('#add-on__container') && document.querySelector('#add-on__container').classList.add('u--hide');
	    // document.querySelector('.buybox__quantity-flex') && document.querySelector('.buybox__quantity-flex').classList.add('u--hide');
	    const buyBox = document.querySelector('.buybox');
	    if(buyBox){
	        const buyBeltWrapper = document.createElement( 'div' );
	        buyBeltWrapper.id = 'buybelt-wrapper-new';
	        buyBox.appendChild( buyBeltWrapper );
	    }


      //add empty buybelt (legacy) for content attachment

      //TODO: This should be replaced by change to pip to add buybelt-wrapper-position div
      try{
        // window.document.getElementById('buybelt-wrapper').parentNode
        let pipRow = document.createElement( 'div' );
        pipRow.classList.add('pip-row');
        if(!isIe11()){
          pipRow.style="display: none"          
        }
        let buyBeltWrapperLegacy = document.createElement( 'div' );
        buyBeltWrapperLegacy.id = 'buybelt-wrapper';
        pipRow.appendChild(buyBeltWrapperLegacy);
        buyBox.parentNode.parentNode.insertAdjacentElement('afterend', pipRow);
      }catch(e){
        console.error(e);
      }

	    //React component is rendered with "loading" flag
	    window.ReactDOM.render(
	      window.React.createElement(window.BuyBeltNew, {loading: true}),
	      document.querySelector('#buybelt-wrapper-new')
	    );

	    //inside pip (pip-buybelt --> pip-buybelt-redesign-react), the tiles experience will be instantiated
	    //with model and other hooks from pip
	}catch(e){
	  console.error(e);
	}
}

function _checkForDisplayLegacyScenario(){
  try{
    const bb = document.querySelector('#buybelt');
    const nbs = document.querySelector('.non-buyable-service');
    const nbsh = document.querySelector('.non-buyable-service__heading');
    if((nbs && nbsh) && !bb){
      //show legacy
      document.querySelector("#buybelt-wrapper").style.display="inline";
      document.querySelector("#buybelt-wrapper").parentNode.style.display="inline";
      return true;
    }else{
      document.querySelector("#buybelt-wrapper").style.display="none";
      document.querySelector("#buybelt-wrapper").parentNode.style.display="none";
      return false;
    }
  }catch(e){
    console.error(e);
  }
}

function initPaypal(){
	try{
		const { view, pipCart } = PIP_HOOKS;

		$(document).off('.paypal');

        $(document).on('click.paypal touchend.paypal', view.selectors.paypalShipToHome, function(e) {
            e.preventDefault();
            e.stopPropagation();

            if(!$(this).parent().hasClass('pseudo-button--disabled')){
                pipCart.paypalAddToCart('ShipToHome');
            }
        });
        $(document).on('click.paypal touchend.paypal', view.selectors.paypalPickUpInStore, function(e) {
            e.preventDefault();
            e.stopPropagation();

            if(!$(this).parent().hasClass('pseudo-button--disabled')){
                pipCart.paypalAddToCart("BOPIS");
            }
        });
        $(document).on('click.paypal touchend.paypal', view.selectors.paypalShipToStore, function(e) {
            e.preventDefault();
            e.stopPropagation();

            if(!$(this).parent().hasClass('pseudo-button--disabled')){
                pipCart.paypalAddToCart("ShipToStore");
            }
        });
        $(document).on('click.paypal touchend.paypal', view.selectors.paypalBuyOnlineDeliverFromStore, function(e) {
            e.preventDefault();
            e.stopPropagation();

            if(!$(this).parent().hasClass('pseudo-button--disabled')){
                pipCart.paypalAddToCart("DeliverFromStore");
            }
        });

  // $(document).off('.paypal');

  // $(document).on('click.paypal touchend.paypal', view.selectors.paypalShipToHome, function(e) {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     if(!$(this).parent().hasClass('pseudo-button--disabled')){
  //       pipCart.paypalAddToCart('ShipToHome');
  //     }

  // });
  // $(document).on('click.paypal touchend.paypal', view.selectors.paypalStore, function(e) {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     if(!$(this).parent().hasClass('pseudo-button--disabled')){
  //       pipCart.paypalAddToCart('ShipToStore');
  //     }

  // });


	}catch(e){
    console.error(e);
	}
}

function initAtcArea(partialReload=false, fulfillmentDetails, selectedOption){
  try{
      if(fulfillmentDetails.showNotifyBox){
        DomAdjuster.hideQuantityButtons();
      }
      DomAdjuster.adjustAtcAreaContent(selectedOption, fulfillmentDetails, partialReload);

  }catch(e){
    console.error(e);
  }
}

function isIe11(){
  try{
    return (!!window.MSInputMethodContext && !!document.documentMode);
  }catch(e){
    console.error(e);
  }
}

export default BuyBeltInit;
